import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const geoMapElement = css`
	.form-group {
		margin-bottom: 0.75em;
	}

	.form-label {
		margin-bottom: 3px;
	}

	.title {
		font-weight: 600;
	}

	.number {
		max-width: 131px;
	}

	.select {
		max-width: 170px;
	}

	.marginsBlock {
		display: flex;
		flex-wrap: wrap;

		.form-group {
			margin-right: 10px !important;
		}

		.number {
			width: 100px;
		}
	}

	.legendBlock {
		display: flex;

		.select {
			width: 100px;
			margin-right: 5px;
		}

		input {
			margin-right: 20px;
		}

		.number {
			max-width: 70px;
		}
	}

	.mapPreview {
		.tooltip {
			opacity: 1;
		}

		.visually-hidden {
			position: absolute !important;
			clip: rect(1px 1px 1px 1px);
			padding: 0 !important;
			border: 0 !important;
			height: 1px !important;
			width: 1px !important;
			overflow: hidden;
		}
	}

	.initialValuesBlock {
		display: flex;
	}

	.initialScaleBlock {
		display: flex;
		align-items: baseline;
		margin-right: 10px;

		.select {
			width: 100px;
			margin-right: 10px;
		}

		input {
			margin-right: 10px;
		}
	}
`;

export const regionDataStyle = css`
	color: #757575;

	.cell {
		padding: 3px 6px !important;
	}

	.cell > input {
		width: 100% !important;
		height: 100% !important;
	}

	.add-row-button {
		margin-top: 5px;
	}

	td:first-child {
		min-width: 250px;
	}
`;

export const mapDataStyle = css`
	width: 100%;
	color: #757575;

	.cell > input {
		width: 100% !important;
		height: 100% !important;
	}

	tr:first-child > .cell:not(:first-child) {
		vertical-align: middle;
		text-align: center;
	}

	.addColumn {
		padding: 0 20px;
		position: relative;
	}
	.addButton {
		cursor: pointer;
		position: absolute;
		top: 50%;
		right: 2px;
		transform: translate(0, -50%);
	}

	.columnDropdown {
		position: absolute;
		top: -1px;
		right: -151px;

		width: 150px;
		z-index: 1;
	}

	.dropdownItem {
		cursor: pointer;
		padding: 5px 10px;
		text-align: left;

		:hover {
			background-color: #f5f5f5;
		}
	}

	.rangeCell {
		.css-spipox-menu-cn {
			z-index: 10;
		}
	}

	.rangeCell > div {
		border: none;
		border-radius: unset;
	}
`;

export const addRowButton = css`
	margin-top: 5px;
	color: #757575 !important;
	border-color: #dddddd !important;

	display: flex;
	align-items: center;
	justify-content: center;

	:hover {
		background-color: whitesmoke !important;
	}
`;

export const deleteRowButton = css`
	cursor: pointer;

	:hover {
		color: gray;
	}
`;

export const colorPickerCell = css`
	position: relative;
	display: flex;

	.colorSquare {
		min-width: 20px;
		height: 20px;
		border-radius: 4px;
		border: 1px solid ${colors.border};
		cursor: pointer;

		margin-right: 10px;
	}
`;

export const paginationWrapper = css`
	display: flex;
	justify-content: center;
	align-items: baseline;
	margin-top: 15px;

	.rowsNumberSelect {
		width: 70px;
		margin-right: 20px;
	}
`;

export const paginationBlock = css`
	justify-content: center;
	margin-bottom: 0;

	.page-item.active .page-link {
		background-color: ${colors.background} !important;
		border-color: ${colors.border} !important;
		z-index: 0;
	}

	.page-link {
		color: ${colors.mainText} !important;

		:hover {
			background-color: ${colors.background} !important;
		}
	}
`;
